<template>
  <footer class="gradient">
    <v-row justify="center" no-gutters class="text-center">
      <v-btn
        v-for="link in menuItems"
        :key="link.name"
        text
        class="my-2"
        :to="link.url"
      >
        {{ link.name }}
      </v-btn>
      <v-col cols="12">
        © 2021 panman Inc.
      </v-col>
    </v-row>
  </footer>
</template>

<script>
import constants from "../../common/constants";

export default {
  components: {
  },
  data: () => ({
    menuItems: constants.menuItems,
  }),
};
</script>

<style>
.gradient {
  background: linear-gradient(to right, #f5f5f5,70%,#a9a9a9);
}

</style>